import { useState } from 'react';

import { DateTime } from 'luxon';

import { useGlobalContext } from '~/lib/contexts/GlobalContext';

import ScheduleHeader from './ScheduleHeader';

const ScheduleWrapper = () => {
  const { currentUser } = useGlobalContext();
  const [currentDate, setCurrentDate] = useState<DateTime>(DateTime.now());
  return (
    <ScheduleHeader
      currentDate={currentDate}
      filterByKey="provider-external-id"
      filterByValue={currentUser.userId}
      participantType="provider"
      setCurrentDate={setCurrentDate}
    />
  );
};

export default ScheduleWrapper;
